import {FormGroup} from "@angular/forms";
//import {ValidationError} from "../utils/validation/validators";
import {HttpErrorResponse} from "@angular/common/http";

export type FieldErrors = {[field: string]: Array<AppError>};

export class AppResponse<T> {

  constructor(
    readonly success: boolean,
    readonly httpError?: HttpErrorResponse,
    readonly body?: T) {
  }

  static success<T>(body?: T): AppResponse<T> {
    return new AppResponse<T>(true, null, body);
  }

  static failure<T>(httpError: HttpErrorResponse): AppResponse<T> {
    return new AppResponse(false, httpError);
  }
}

export interface AppError {
  readonly errorCode: string;
}

export interface AppValidationError extends AppError {
  readonly messages: Array<ValidationMessage>;
}

export interface ValidationMessage {
  readonly field: string;
  readonly code: string;
}

export function isValidationError(error: any): error is AppValidationError {
  return error && error.errorCode === "validation";
}

export function applyFieldErrors(messages: Array<ValidationMessage>, form: FormGroup) {
  for (let message of messages) {
    let field = message.field;
    if (!form.controls[field].errors) {
      form.controls[field].setErrors({});
    }
    //form.controls[field].errors[message.code] = new ValidationError(message.code);
  }
}
